import React, { forwardRef } from 'react';
import styled from 'styled-components';

interface CardContentProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onClick: (e: React.MouseEvent) => void;
  onMouseDown: (e: React.MouseEvent) => void;
}

// カードのテキストエリア
const StyledCardContent = styled.textarea`
  width: 100%;
  height: auto;
  border: none;
  background: transparent;
  resize: none;
  font-family: inherit;
  font-size: 14px;
  margin-bottom: 10px;
  cursor: text;
  flex-grow: 1;
  overflow-y: auto;
  &:focus {
    outline: none;
  }
`;

const CardContent = forwardRef<HTMLTextAreaElement, CardContentProps>(({ 
  value, 
  onChange, 
  onClick, 
  onMouseDown 
}, ref) => {
  return (
    <StyledCardContent 
      ref={ref}
      value={value} 
      onChange={onChange} 
      onClick={onClick}
      onMouseDown={onMouseDown}
    />
  );
});

CardContent.displayName = 'CardContent';

export default CardContent; 